import { Link, useNavigate } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'

import routes from '../../routers'
import { LIMIT_RECIPES, isFreePlan } from '../../utils/constants'
import { setShowModalTrial } from '../../redux/actions/ui'
import Button from '../ButtonCustom'

import './ListRecipes.css'

export const LockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 1 1 6 0v3H9z"
    />
  </svg>
)

const ListRecipes = ({
  title,
  loadBtn = false,
  innerRecipes = '',
  children,
  visibleButtonAddRecipe = true,
  onClick = () => {},
  titleClass = '',
  userData,
  showCountRecipes = true,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const statusNeedPay = isFreePlan(userData)

  const usage = userData?.recipe_usage

  const linkToCreateRecipes = () => {
    return statusNeedPay && userData?.recipes_count >= LIMIT_RECIPES
      ? dispatch(setShowModalTrial(true))
      : navigate(routes.addRecipe)
  }

  return (
    <div className={`innerListRecipes ${innerRecipes}`}>
      <div
        className={`innerHeaderRecipes ${!visibleButtonAddRecipe ? 'justify-content-center' : ''}`}
      >
        <h1 className={`titleList ${titleClass}`}>
          {title}
          {showCountRecipes && (
            <div className="countRecipes">
              <span className="numberRecipes">
                {statusNeedPay && usage
                  ? `${Math.min(usage.used, usage.limit)} of ${usage.limit} free recipes`
                  : `${userData?.recipes_count} Uploads`}
              </span>
              {statusNeedPay && Number(userData?.recipes_count || 0) > 0 && (
                <>
                  <span>|</span>
                  <Link to={`${routes.settings}#subscription`} className="linkToManage">
                    Upgrade to PRO
                  </Link>
                </>
              )}
            </div>
          )}
        </h1>
        {visibleButtonAddRecipe ? (
          <Button
            title="Add New Recipes"
            onClick={linkToCreateRecipes}
            style="addNewRecipes recipeBtnAdd"
          />
        ) : null}
      </div>
      {statusNeedPay && usage?.locked && showCountRecipes && visibleButtonAddRecipe ? (
        <p className="lockedRecipesNote">
          <LockIcon /> {usage.locked} older {usage.locked === 1 ? 'recipe is' : 'recipes are'}{' '}
          locked on the free plan. They are safe, and your family can still see them.{' '}
          <Link to={`${routes.settings}#subscription`}>Upgrade to Pro to unlock them all.</Link>{' '}
          Cancel any time.
        </p>
      ) : null}
      <div className="innerListRecipesAll">{children}</div>
      {loadBtn ? (
        <Button onClick={onClick} title="Load more..." style="loadBtn" titleStyle="loadBtnText" />
      ) : null}
    </div>
  )
}

export default connect(({ user }) => ({ userData: user.data }))(ListRecipes)
